export default {
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL ?? "/api",
  authBaseUrl: process.env.VUE_APP_AUTH_BASE_URL ?? "/auth",
  oauthBaseUrl: process.env.VUE_APP_OAUTH_BASE_URL,
  version: process.env.VUE_APP_VERSION,
  nodeEnv: process.env.NODE_ENV,
  baseUrl: process.env.BASE_URL,
  gaMeasurementId: process.env.VUE_APP_GA_MEASUREMENT_ID,
  gaConnectedSiteTags: process.env.VUE_APP_GA_CONNECTED_SITE_TAGS,
  recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
  recaptchaHost: process.env.VUE_APP_RECAPTCHA_HOST,
  gtmId: process.env.VUE_APP_GTM_ID,
  gtmNonce: process.env.VUE_APP_GTM_NONCE,
  myRecordsBaseUrl: process.env.VUE_APP_PROFILE_MY_RECORDS_URL,
  casIamserviceResponseUrl: process.env.VUE_APP_CAS_IAM_SERVICE_RESPONSE_URL,
  enableCampaignCode: process.env.VUE_APP_ENABLE_CAMPAIGN_CODE,
};
